// Expense.js
import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  Heading,
  Input,
  Stack,
  Textarea,
  FormControl,
  FormLabel,
  VStack,
  useToast,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
} from "@chakra-ui/react";

const Expense = () => {
  const toast = useToast();

  const [grocery, setGrocery] = useState({
    item: "",
    unitPrice: "",
    note: "",
  });

  const [staff, setStaff] = useState({
    name: "",
    mobile: "",
    address: "",
    payment: "",
  });

  const [expenses, setExpenses] = useState([]);

  // Grocery Change
  const handleGroceryChange = (e) => {
    setGrocery({
      ...grocery,
      [e.target.name]: e.target.value,
    });
  };

  // Staff Change
  const handleStaffChange = (e) => {
    setStaff({
      ...staff,
      [e.target.name]: e.target.value,
    });
  };

  // Save Grocery
  const submitGrocery = () => {
    const newExpense = {
      type: "Grocery",
      name: grocery.item,
      amount: grocery.unitPrice,
      note: grocery.note,
    };

    setExpenses([...expenses, newExpense]);

    toast({
      title: "Grocery Expense Saved",
      status: "success",
      duration: 2000,
      isClosable: true,
    });

    setGrocery({
      item: "",
      unitPrice: "",
      note: "",
    });
  };

  // Save Staff
  const submitStaff = () => {
    const newExpense = {
      type: "Staff",
      name: staff.name,
      amount: staff.payment,
      note: staff.address,
    };

    setExpenses([...expenses, newExpense]);

    toast({
      title: "Staff Expense Saved",
      status: "success",
      duration: 2000,
      isClosable: true,
    });

    setStaff({
      name: "",
      mobile: "",
      address: "",
      payment: "",
    });
  };

  return (
    <Box p={5} bg="gray.100" minH="100vh">
      {/* Main Layout */}
      <Grid
        templateColumns={{ base: "1fr", lg: "1fr 1fr" }}
        templateRows={{ base: "auto", lg: "1fr 1fr" }}
        gap={5}
        h="95vh"
      >
        {/* Grocery Form */}
        <Box
          bg="white"
          p={5}
          borderRadius="lg"
          boxShadow="md"
          overflowY="auto"
          h="45vh"
        >
          <Heading size="md" mb={4} color="green.600">
            Grocery Expense
          </Heading>

          <VStack spacing={4}>
            <FormControl>
              <FormLabel>Item Name</FormLabel>
              <Input
                placeholder="Enter item"
                name="item"
                value={grocery.item}
                onChange={handleGroceryChange}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Unit Price</FormLabel>
              <Input
                type="number"
                placeholder="Enter price"
                name="unitPrice"
                value={grocery.unitPrice}
                onChange={handleGroceryChange}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Note</FormLabel>
              <Textarea
                placeholder="Write note"
                name="note"
                value={grocery.note}
                onChange={handleGroceryChange}
              />
            </FormControl>

            <Button colorScheme="green" width="full" onClick={submitGrocery}>
              Save Grocery Expense
            </Button>
          </VStack>
        </Box>

        {/* Grocery Table */}
        <Box
          bg="white"
          p={5}
          borderRadius="lg"
          boxShadow="md"
          overflowY="auto"
          h="45vh"
        >
          <Heading size="md" mb={4}>
            Grocery Records
          </Heading>

          <TableContainer>
            <Table size="sm">
              <Thead bg="gray.100">
                <Tr>
                  <Th>Item</Th>
                  <Th>Price</Th>
                  <Th>Note</Th>
                </Tr>
              </Thead>

              <Tbody>
                {expenses
                  .filter((e) => e.type === "Grocery")
                  .map((expense, index) => (
                    <Tr key={index}>
                      <Td>{expense.name}</Td>
                      <Td>₹ {expense.amount}</Td>
                      <Td>{expense.note}</Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>

        {/* Staff Form */}
        <Box
          bg="white"
          p={5}
          borderRadius="lg"
          boxShadow="md"
          overflowY="auto"
          h="45vh"
        >
          <Heading size="md" mb={4} color="blue.600">
            Staff Expense
          </Heading>

          <Stack spacing={4}>
            <FormControl>
              <FormLabel>Staff Name</FormLabel>
              <Input
                placeholder="Enter name"
                name="name"
                value={staff.name}
                onChange={handleStaffChange}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Mobile Number</FormLabel>
              <Input
                placeholder="Enter mobile"
                name="mobile"
                value={staff.mobile}
                onChange={handleStaffChange}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Address</FormLabel>
              <Textarea
                placeholder="Enter address"
                name="address"
                value={staff.address}
                onChange={handleStaffChange}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Payment</FormLabel>
              <Input
                type="number"
                placeholder="Enter payment"
                name="payment"
                value={staff.payment}
                onChange={handleStaffChange}
              />
            </FormControl>

            <Button colorScheme="blue" width="full" onClick={submitStaff}>
              Save Staff Expense
            </Button>
          </Stack>
        </Box>

        {/* Staff Table */}
        <Box
          bg="white"
          p={5}
          borderRadius="lg"
          boxShadow="md"
          overflowY="auto"
          h="45vh"
        >
          <Heading size="md" mb={4}>
            Staff Records
          </Heading>

          <TableContainer>
            <Table size="sm">
              <Thead bg="gray.100">
                <Tr>
                  <Th>Name</Th>
                  <Th>Payment</Th>
                  <Th>Address</Th>
                </Tr>
              </Thead>

              <Tbody>
                {expenses
                  .filter((e) => e.type === "Staff")
                  .map((expense, index) => (
                    <Tr key={index}>
                      <Td>{expense.name}</Td>
                      <Td>₹ {expense.amount}</Td>
                      <Td>{expense.note}</Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      </Grid>
    </Box>
  );
};

export default Expense;
